/**
 * Define and Export Action Types
 */

export const PROGRESS_CLEAR = 'PROGRESS_CLEAR'
export const PROGRESS_UPDATE = 'PROGRESS_UPDATE'
